import apiClient from '../client';
import $U from '../urls';

export const fetchProduct = (id, params = {}) => {
  return apiClient.request('GET', `${$U.PRODUCT}${id}`, params);
};

export const fetchProductJSON = (id, params = {}) => {
  return fetchProduct(id, { ...params, format: 'json' });
};

export const fetchProductList = (params = {}) => {
  return apiClient.request('GET', $U.PRODUCT_LIST, params);
};

export const fetchProductListJSON = params => {
  return fetchProductList({ ...params, format: 'json' });
};

export const getStockNotice = (id) => {
  return apiClient.request('POST', $U.PRODUCT_GET_NOTICE, `product=${id}`);
};

export const getPriceNotice = (id) => {
  return apiClient.request('POST', $U.PRODUCT_PRICE_NOTICE, `product=${id}`);
};

